import { familyOfRuleId, familySegment, setRulesPath } from './ruleSetRoutes';

/**
 * Where a card, a rule or a case opens — one place, so every list links the same way
 * (UX review P1-3). Lists show a card's short tail (`shortId`); the link carries the full id,
 * which is what Investigate's card search needs.
 */

/** A card's decisions and cases: Investigate › decisions by card. */
export function cardLink(cardId: string): string {
  return `/investigate?card=${encodeURIComponent(cardId)}`;
}

/** Not a rule: the engine's fail-safe marker, which some decision lists carry beside the rule ids. */
export const NOT_A_RULE = new Set(['FAIL_SAFE']);

/**
 * A rule in its set's page, opened in its editor. The family is guessed from the id
 * (`PB-…` → Pattern base, anything else → Transaction); the page moves to the other family's
 * tab when the rule turns out to live there.
 *
 * Wave 5: the set is the route — `setId` when the hit names its set (2c `set` on hits), else
 * the primary. With neither known yet (the shell's document still loading) the link is the
 * pre-Wave-5 `/rules/<family>?rule=`, which the router redirects once the primary is known.
 */
export function ruleLink(ruleId: string, setId?: string, primaryId?: string | null): string {
  const kind = familyOfRuleId(ruleId);
  const set = setId || primaryId;
  if (set) return setRulesPath(set, kind, ruleId);
  return `/rules/${familySegment(kind)}?rule=${encodeURIComponent(ruleId)}`;
}

// 2c rule sets
/** `cnp-risk/RB-01` → the set and the rule; a plain `RB-01` has no set (the primary). */
export function splitSetRule(id: string): { setId?: string; ruleId: string } {
  const at = id.indexOf('/');
  return at > 0 ? { setId: id.slice(0, at), ruleId: id.slice(at + 1) } : { ruleId: id };
}
